import { CheckCircle2 } from 'lucide-react';
import { observer } from 'mobx-react';
import { emptyFragment } from '../../../EmptyFragment';
import { T } from '../../../Translations';
import ToastStore from '../Store';
import { ToastMessage } from '../Store/Types';
import DismissButton from './DismissButton';
import UndoButton from './UndoButton';

interface Props {
  store: ToastStore;
  toast: ToastMessage;
}

function Content({ store, toast }: Props) {
  return (
    <div
      className="pointer-events-auto flex max-w-lg items-center gap-3 rounded-lg bg-foreground py-2 pl-4 pr-2 text-background"
      style={{ boxShadow: 'var(--elevation-medium)', fontSize: 'var(--text-sm)' }}
    >
      <CheckCircle2
        className="h-4 w-4 flex-shrink-0"
        style={{ color: 'var(--accent)' }}
        aria-hidden="true"
      />
      <p className="truncate">
        <T {...toast.message} />
      </p>
      {toast.undo.map(() => <UndoButton store={store} />).getOrElse(emptyFragment)}
      <DismissButton store={store} />
    </div>
  );
}

export default observer(Content);
